import React, { useContext } from 'react';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { ClusterContext } from 'lib/googleMap/GoogleCluster';

const withCluster = <P extends object>(WrappedComponent:(props: P) =>ReactJSXElement): (props: Omit<P, 'cluster'>) =>ReactJSXElement => (props) => {
  const sampleCtx = useContext(ClusterContext);
  return (
    // @ts-ignore
    <WrappedComponent
      {...props}
      cluster={sampleCtx}
    />
  );
};

export default withCluster;
